<template>
  <div class="d-flex align-center">
    <b-dropdown-item @click="dialog = true"
      >Allocate Case Officer</b-dropdown-item
    >
    <b-modal
      tabindex="0"
      v-model="dialog"
      title="Allocate Case Officer"
      hide-footer
      ignore-enforce-focus-selector=".select2-search__field"
      size="sm"
      centered
    >
      <form-wrapper @submit="submit">
        <b-row class="pb-0">
          <b-col cols="12">
            <autocomplete
              v-model="case_officer"
              label="Case Officer"
              :items="masterCaseOffer"
              :multiple="false"
              :max="1"
              rules="required"
            >
            </autocomplete>
          </b-col>
        </b-row>
        <div class="d-flex">
          <div class="flex-grow-1"></div>
          <b-button variant="outline-danger mx-3" @click="dialog = false"
            >Cancel
          </b-button>
          <b-button variant="success" type="submit">Submit </b-button>
        </div>
      </form-wrapper>
    </b-modal>
  </div>
</template>

<script>
import donorService from "../../assets/services/donor.service";
import Autocomplete from "../form/Autocomplete.vue";
export default {
  components: { Autocomplete },
  props: {
    item: {},
  },
  data() {
    return {
      dialog: false,
      case_officer: "",
    };
  },
  methods: {
    async submit() {
      const vm = this;
      let { case_officer } = vm;
      let { final_donor_id } = vm.item;
      try {
        vm.$loader.show();
        let { data } = await donorService.updateFinalDonorStatus({
          dml_indicator: "CU",
          case_officer,
          final_donor_id,
        });
        let { status, msg } = data;
        vm.dialog = false;
        if (!status) {
          vm.$alert.show(msg);
        }
        vm.$emit("fetch");
        vm.$loader.hide();
      } catch (error) {
        vm.$alert.show(error.message);
        vm.$loader.hide();
      }
    },
    open() {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure, Do you want to terminate this donor?",
        onConfirm: () => {
          vm.dialog = true;
        },
      });
    },
  },
};
</script>

<style></style>
